import { Skeleton } from 'antd';
import { CSSProperties, FC } from 'react';
import { useHandbook, useHandbookKeys } from '~/controllers/handbook';

interface Props {
  value?: string;
}

const LocationField: FC<Props> = (props) => {
  const { value } = props;

  const { data: handbook, isLoading: handbookIsLoading } = useHandbook();
  const handbookKeys = useHandbookKeys();

  const location = handbook?.handbooks
    ?.find((item) => item.key === handbookKeys.region)
    ?.values?.find((item) => item.apiValue === value);

  if (handbookIsLoading) return <Skeleton.Button style={loadingStyle} />;
  return <>{location?.localizedValue || value}</>;
};

const loadingStyle: CSSProperties = { opacity: 0.3 };

export default LocationField;
